import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DashboardService } from 'utility/services/dashboard'
import { useAuth } from 'context/user'
import { LoaderBar, PageHeader, ImageContainer, EmptyBox, TileCard, CardBody, AvatarCircle } from 'components'
import { Grid } from 'semantic-ui-react'
import { DashboardHeader } from 'components/DashboardHeader'
import { AppPrimaryButton } from 'elements'
// no local styled-components; using shared components/utilities

// Using shared components; no local container or avatar CSS

// Using shared ImageContainer instead of a local styled img

// Using plain h3 styling inline to match shared typography

// Using shared EmptyBox instead of a local empty state styled block

export const CustomerGroupSelectionScreen = () => {
    const navigate = useNavigate()
    const { user } = useAuth()
    const [customerGroups, setCustomerGroups] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        fetchCustomerGroups()
    }, [])

    const fetchCustomerGroups = async () => {
        try {
            setLoading(true)
            setError('')
            const companyId = user?.Companies?.[0]?.CompanyId
            if (!companyId) {
                throw new Error('Company ID not found')
            }

            const response = await DashboardService.getCustomerGroups(companyId)
            setCustomerGroups(response || [])
        } catch (err) {
            console.error('Error fetching customer groups:', err)
            setError('Failed to load customer groups')
        } finally {
            setLoading(false)
        }
    }

    const handleGroupClick = group => {
        navigate('/app/dashboard/customers', {
            state: {
                customerGroup: group,
                groupId: group.CustomerGroupId,
            },
        })
    }

    const renderGroupLogo = group => {
        if (group.LogoUrl && group.LogoUrl.trim() !== '') {
            return (
                <ImageContainer
                    src={group.LogoUrl}
                    alt={`${group.CustomerGroupName} logo`}
                    width="90px"
                    height="90px"
                    round
                    onError={e => {
                        e.target.style.display = 'none'
                        e.target.nextSibling.style.display = 'flex'
                    }}
                />
            )
        }
        return (
            <AvatarCircle>
                {group.CustomerGroupName.charAt(0).toUpperCase()}
            </AvatarCircle>
        )
    }

    if (loading) {
        return <LoaderBar content="Loading customer groups..." />
    }

    return (
        <>
            <div style={{ padding: '0 1rem 1rem' }}>
                <DashboardHeader title="Restaurant Excellence Visit" />
                <PageHeader title="Customer Groups" />

            {error && (
                <div className="ui negative message">
                    <div className="header">Error</div>
                    <p>{error}</p>
                </div>
            )}

                {customerGroups.length === 0 && !loading ? (
                <div style={{ textAlign: 'center', padding: '2rem 1rem' }}>
                    <EmptyBox text="No Customer Groups Found" />
                    <AppPrimaryButton
                        onClick={fetchCustomerGroups}
                        style={{ marginTop: '1rem' }}
                    >
                        Refresh
                    </AppPrimaryButton>
                </div>
                ) : (
                <Grid stackable doubling columns={3} padded style={{ marginTop: '0.5rem' }}>
                    {customerGroups.map(group => (
                        <Grid.Column key={group.CustomerGroupId}>
                            <TileCard onClick={() => handleGroupClick(group)}>
                                <CardBody>
                                    {renderGroupLogo(group)}
                                    <h3
                                        style={{
                                            color: '#2c3e50',
                                            fontSize: '1.25rem',
                                            fontWeight: 700,
                                            margin: 0,
                                            lineHeight: 1.3,
                                            letterSpacing: '0.5px',
                                        }}
                                    >
                                        {group.CustomerGroupName}
                                    </h3>
                                </CardBody>
                            </TileCard>
                        </Grid.Column>
                    ))}
                </Grid>
                )}
            </div>
        </>
    )
}
